import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,MDBDataTable, MDBRow, MDBCol,MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBTypography  } from 'mdbreact';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';
import { Chart } from "react-google-charts";



export default class superadminhome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',

            registerin:'',
            registerout:'',
            payoutno:'',//ภายนอกยังไม่ชำระ
            payout:'',//ภายนอกชำระแล้ว
            payin:'',//ภายใน
            articleout:'',
            articlein	:'',
            articlesmin : '',
            articlesmout	 : '',

        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
      }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle.php')
          api.get('registercon/selectnumall')
           .then(res => {
             console.log(res);
             if (res.data.length >0) {
              this.setState({ registerin: res.data[0].registerin})
              this.setState({ registerout: res.data[0].registerout})
              this.setState({ articleout: res.data[0].articleout})
              this.setState({ articlein: res.data[0].articlein})
              this.setState({ articlesmin: res.data[0].articlesmin})
              this.setState({ articlesmout: res.data[0].articlesmout})
             // this.setState({ payin: res.data[0].payin})
             }
           //  this.setState({ bankname: res.data, loading: false })
            // this.setState({ article: res.data})
           }) 
         }, 400);

      }


      updateat(){
        setTimeout(() => {
           
        //  Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle.php')
        api.get('registercon/selectArticleconnpayforadmin')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }






    render() {





      const datast = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อเรื่อง',
            field: 'name_article',
            sort: 'name_article',
            width: 150
          },
          {
            label: 'ผู้เขียนบทความ',
            field: 'name_present',
            sort: 'name_present',
            width: 150
          },
          {
            label: 'สาขา',
            field: 'major_precent',
            sort: 'major_precent',
            width: 150
          },
          {
            label: 'ไฟล์บทความ',
            field: 'send_uploadeword1',
            sort: 'send_uploadeword1',
            width: 150
          },
      
        
        ],
  
  
        rows: [...this.state.article.map((data, i) => (
      
          {
     
  
             list: <>{i+1}</>,
             name_article: <>{data.name_article}</>,
             name_present: <>{data.name_present}</>,
             major_precent: <>{data.major_precent}</>,
             send_uploadeword1: <><MDBBtn color="indigo" size="sm" href={`${this.state.url+data.send_uploadeword1}`}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={`${this.state.url+data.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn></>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
          // searching ={true}
            searchLabel="ค้นหา ชื่อ-นามสกุล"
            striped
            bordered
            small 
            entries={50}
          // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
             theadColor="grey lighten-1"
          //  theadColor={"#ff4444"}
            />

            const sds = Number(this.state.registerin )+Number(this.state.registerout );
            const sds2 = Number(this.state.articlein )+Number(this.state.articleout );
            const sds3 = Number(this.state.articlesmin )+Number(this.state.articlesmout );

        //จำนวนผู้ลงทะเบียน
           const data = [
              ["Task", "Hours per Day"],
              ["ภายใน", Number(this.state.registerin)],
              ["ภายนอก", Number(this.state.registerout)],
            
            ];
            
           const options = {
              title: "จำนวนผู้ลงทะเบียน",
              is3D: true,
            };

              //จำนวนบทความโครงการ
           const data2 = [
            ["Task", "Hours per Day"],
            ["ภายใน", Number(this.state.articlein )],
            ["ภายนอก", Number(this.state.articleout )],
          
          ];
          
         const options2 = {
            title: "จำนวนบทความโครงงาน",
            is3D: true,
          };
          
               //จำนวนบทความสัมมนา
               const data3 = [
                ["Task", "Hours per Day"],
                ["ภายใน", Number(this.state.articlesmin)],
                ["ภายนอก", Number(this.state.articlesmout )],
              
              ];
              
             const options3 = {
                title: "จำนวนบทความสัมมนา",
                is3D: true,
              };


        return (
            <MDBContainer fluid>
            <div>
            {/* <MDBIcon fas icon="book-open" /> */}
            <p className="text-right font-weight-bold">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 4 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
            <MDBAlert color="secondary" >
                    <PageHeader
                        className="site-page-header"
                       // onBack={() => null}
                        title="ข้อมูลภาพรวม"
                        subTitle="ข้อมูลภาพรวม"
                        avatar={{ src: 'https://www.tutoroui-plus.com/assets/img/icon/icon01.png' }}
                       // backIcon={() => null}
                    />
            </MDBAlert>

            <MDBRow>

            <MDBCol sm="4">
        <MDBCard style={{ width: "100%", }}>
                        <MDBCardBody>
                          
                            <MDBCardTitle>  <MDBTypography note noteColor='primary' noteTitle='จำนวนผู้ลงทะเบียน'> </MDBTypography></MDBCardTitle>
                            <h3 >ทั้งหมด {sds}</h3>
                            {/* <MDBCardTitle tag="h6" sub className="mb-2 text-muted">
                                Panel title
                            </MDBCardTitle> */}
                            {/* <MDBCardText>
                                Some quick example text to build on the panel title and make up
                                the bulk of the panel's content.{" "}
                            </MDBCardText> */}
                             
                             <MDBRow>
                              <MDBCol sm="6"><h5>ภายใน<br/>{this.state.registerin}</h5></MDBCol>
                              <MDBCol sm="6"><h5>ภายนอก<br/>{this.state.registerout}</h5></MDBCol>
                            </MDBRow>

                            {/* <a href="#!" className="card-link">
                                Panel link
                            </a>
                            <a href="#!" className="card-link">
                                Another link
                            </a> */}
                            
                        </MDBCardBody>
                 </MDBCard>
         </MDBCol>
            <MDBCol sm="4">
                    <MDBCard style={{ width: "100%",  }}>
                        <MDBCardBody>
                            <MDBCardTitle><MDBTypography note noteColor='warning' noteTitle='บทความโครงงาน'> </MDBTypography> </MDBCardTitle>
                            <h3 >ทั้งหมด {sds2}</h3>
                            <MDBRow>
                              <MDBCol sm="6"><h5>บทความภายใน<br/>{this.state.articlein}</h5></MDBCol>
                              <MDBCol sm="6"><h5>บทความภายนอก<br/>{this.state.articleout}</h5></MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                 </MDBCard>
          </MDBCol>
          <MDBCol sm="4">
          <MDBCard style={{ width: "100%",  }}>
                          <MDBCardBody>
                              <MDBCardTitle><MDBTypography note noteColor='info' noteTitle='บทความสัมมนา'> </MDBTypography></MDBCardTitle>
                              <h3 >ทั้งหมด {sds3}</h3>   
                            <MDBRow>
                              <MDBCol sm="6"><h5>บทความภายใน<br/>{this.state.articlesmin}</h5></MDBCol>
                              <MDBCol sm="6"><h5>บทความภายนอก<br/>{this.state.articlesmout}</h5></MDBCol>
                            </MDBRow>
                          </MDBCardBody>
                      </MDBCard>
          </MDBCol>
       
      </MDBRow>
{/* กราฟ */}
      <MDBRow>

<MDBCol sm="4">
<MDBCard style={{ width: "100%", marginTop: "1rem" }}>
            <MDBCardBody>
            <Chart
      chartType="PieChart"
      data={data}
      options={options}
      width={"100%"}
      height={"300px"}
    />
            </MDBCardBody>
     </MDBCard>
</MDBCol>
<MDBCol sm="4">
        <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
            <MDBCardBody>
            <Chart
      chartType="PieChart"
      data={data2}
      options={options2}
      width={"100%"}
      height={"300px"}
    />
            </MDBCardBody>
     </MDBCard>
</MDBCol>
<MDBCol sm="4">
        <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
            <MDBCardBody>
            <Chart
      chartType="PieChart"
      data={data3}
      options={options3}
      width={"100%"}
      height={"300px"}
    />
            </MDBCardBody>
     </MDBCard>
</MDBCol>

</MDBRow>
             

            </div>
            </MDBContainer>
        )
    }
}
